import { render, staticRenderFns } from "./MoreCard.vue?vue&type=template&id=c4a2bb4c&scoped=true"
import script from "./MoreCard.vue?vue&type=script&lang=js"
export * from "./MoreCard.vue?vue&type=script&lang=js"
import style0 from "./MoreCard.vue?vue&type=style&index=0&id=c4a2bb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a2bb4c",
  null
  
)

export default component.exports